
import Vue from "vue";
import LoginApis from "@/api/loginApis";
import { __TOKEN_KEY__ } from "@/api/common";
import Component from "vue-class-component"; // 导入组件装饰器

@Component({
  directives: {
    submit: {
      bind: (el, { value }, vnode) => {
        el.addEventListener("keyup", (ev) => {
          if (ev.keyCode === 13) {
            vnode.context.login("form");
          }
        });
      },
    },
  },
})
export default class Login extends Vue {
  name = "login";
  weChatLoginLoading = false;
  isLogining = false;
  loginForm = {
    username: null,
    password: null,
  };
  shortcutLoginUsers = [];
  rules = {
    username: [
      {
        required: true,
        message: "请输入用户名",
      },
    ],
    password: [
      {
        required: true,
        message: "请输入密码",
      },
    ],
  };
  returndata = ""; // 登录前初始化权限服务器缓存-地址
  key = ""; //// 登录前初始化权限服务器缓存-key
  setLogOutCookieUrl = ""; // 退出调用权限服务器地址
  wxChatQrCodePath = ""; // 二维码显示
  created() {
    this.key = `iCTRWeixin_${new Date().getTime()}`;
    this.shortcutLoginUsers = [];

    // 当前站点退出后调用权限系统退出
    this.setLogOutCookieUrl = sessionStorage.getItem("setLogOutCookieUrl");
    // 微信登录二维码获取
    this.wxQRLogin();

    // 登录页加载后如果有u、b则执行快捷登录
    let u = this.$route.query.u;
    let b = this.$route.query.b;
    if (u != null && b != null) {
      this.shortcutLogin(u, b);
    }
    // 登录前初始化服务器缓存-地址
    this.returndata = process.env.ShortcutLogin_URL + "&k=" + this.key;
    // 判断没有退出操作时直接获取快捷登录用户，若有退出操作则在iframe的load中处理
    if (this.setLogOutCookieUrl == null) {
      // 获取快捷登录用户
      this.getShortcutLoginUsers();
    }
    // 清理所有的客户端session
    sessionStorage.clear();
  }
  onLoadLogout() {
    if (this.setLogOutCookieUrl != null) {
      // 获取快捷登录用户
      this.getShortcutLoginUsers();
    }
  }
  // 微信二维码获取
  wxQRLogin() {
    this.weChatLoginLoading = true;
    LoginApis.getWxQR(encodeURIComponent(window.location.href)) // 编码当前url
      .then(
        (result) => {
          this.wxChatQrCodePath = result.data;
          this.weChatLoginLoading = false;
        },
        (response) => {
          this.weChatLoginLoading = false;
        }
      );
  }
  // 账号密码登录
  login(formName) {
    console.log(this.$refs[formName]);
    this.$refs[formName].validate((valid) => {
      if (!valid) return;
      this.isLogining = true;
      // 进行登录接口
      LoginApis.login(this.loginForm)
        .then((res) => {
          const data = res.data;
          window.sessionStorage.setItem("__TOKEN_KEY__", data.access_token);
          window.sessionStorage.setItem("user", JSON.stringify(data));
          window.sessionStorage.setItem(
            "menuList",
            JSON.stringify(data.menuList)
          );
          this.isLogining = false;
          let redirect = this.$route.query.redirect;
          let payLoad = res.data.pay_load;
          // 设置写登录cookie参数，在母板组件Navbar中使用(实际跳转后使用，主要是解决cookie异步无法写入问题)
          let setLoginCookieUrl = process.env.SetCookie_URL + payLoad;
          sessionStorage.setItem("setLoginCookieUrl", setLoginCookieUrl);
          // 实际跳转
          this.$router.push({
            path: "/",
          });
        })
        .catch((error) => {
          console.log(error);
          this.isLogining = false;
          let data = error.response.data;
          this.$message.error(data.message);
        });
    });
  }
  // 快捷登录
  shortcutLogin(userId, billStr) {
    let data = {
      userId,
      billStr,
    };
    this.isLogining = true;
    LoginApis.shortcutLogin(data)
      .then((res) => {
        const data = res.data;
        window.sessionStorage.setItem("__TOKEN_KEY__", data.access_token);
        window.sessionStorage.setItem("user", JSON.stringify(data));
        window.sessionStorage.setItem(
          "menuList",
          JSON.stringify(data.menuList)
        );
        this.isLogining = false;
        let redirect = this.$route.query.redirect;
        let payLoad = res.data.pay_load;

        let setLoginCookieUrl = process.env.SetCookie_URL + payLoad;
        sessionStorage.setItem("setLoginCookieUrl", setLoginCookieUrl);
        this.$router.push({
          path: redirect || "/",
        });
      })
      .catch((error) => {
        let data = error.response.data;
        this.$message.error(data.message);
        this.isLogining = false;
      });
  }
  // 快捷登录用户获取
  getShortcutLoginUsers() {
    // 获取快捷登录api
    LoginApis.getReturnData(this.key).then((res) => {
      this.shortcutLoginUsers = res.data == null ? [] : res.data;
    });
  }
}
